import { render, staticRenderFns } from "./WhatsappChat.vue?vue&type=template&id=a4dcbb9e&scoped=true&"
import script from "./WhatsappChat.vue?vue&type=script&lang=js&"
export * from "./WhatsappChat.vue?vue&type=script&lang=js&"
import style0 from "./WhatsappChat.vue?vue&type=style&index=0&id=a4dcbb9e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4dcbb9e",
  null
  
)

export default component.exports